import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { DocumentType, EFolderFilingRule, FieldLayout } from './types';

export interface SetDocumentMasterParams {
  documentId: string;
  displayName: string;
  layout?: FieldLayout | null;
  draftLayout?: FieldLayout | null;
  scope?: string;
  inUse?: boolean;
  filenamePrefix: string | null;
  classificationReviewThreshold?: number;
  extractionReviewThreshold?: number;
  borrowerReviewThreshold?: number;
  isClassificationThresholdUpdatedByUser?: boolean;
  isBorrowerThresholdUpdatedByUser?: boolean;
  highConfThresh?: number;
  filingRules?: EFolderFilingRule[];
}

export interface SetDocumentMasterResponse {
  success: boolean;
  documentType: DocumentType;
}

const setDocumentMaster: MutationFunction<
  SetDocumentMasterResponse,
  SetDocumentMasterParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockMaster);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const body = {
    displayName: args.displayName,
    layout: args.layout,
    scope: args.scope,
    inUse: args.inUse,
    filenamePrefix: args.filenamePrefix,
    classificationReviewThreshold: args.classificationReviewThreshold,
    extractionReviewThreshold: args.extractionReviewThreshold,
    borrowerReviewThreshold: args.borrowerReviewThreshold,
    isClassificationThresholdUpdatedByUser:
      args.isClassificationThresholdUpdatedByUser,
    isBorrowerThresholdUpdatedByUser: args.isBorrowerThresholdUpdatedByUser,
    highConfThresh: args.highConfThresh,
    ...(args.filingRules !== undefined
      ? { filingRules: args.filingRules }
      : {}),
    ...(args.draftLayout !== undefined
      ? { draftLayout: args.draftLayout }
      : {}),
  };

  const response = await authTokenHttp<SetDocumentMasterResponse>(
    `/document-types/${args.documentId}`,
    {
      method: 'PUT',
      body,
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set document type');
};

export default setDocumentMaster;

const _mockMaster = {
  success: true,
  documentType: {
    id: 'mock-document-type-id',
    name: 'mock-document-type-name',
    displayName: 'mock-document-type-display-name',
    fields: [],
    layout: undefined,
    draftLayout: undefined,
    scope: undefined,
    inUse: true,
    filenamePrefix: null,
    classificationReviewThreshold: 0,
    extractionReviewThreshold: 0,
    borrowerReviewThreshold: 0,
    highConfThresh: 0,
    filingRules: [],
  },
};
